// extracted by mini-css-extract-plugin
module.exports = {"noPermissionItem":"permission-check_noPermissionItem__2tE6n"};